export default "__VITE_ASSET__e0a8c6d3__"